module.exports = __webpack_public_path__ + "img/edit-icon.8922f4ef.png";